/**
 * 数値か否か（null と Infinity は数値扱いしない）
 * @param obj
 * @returns {boolean}
 */
export const isNumber = (obj)=>{
    return obj !== null && isFinite(obj);
}
